var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrecticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 60,
    viewBox: "0 0 78 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9011 2.31487C71.9121 -0.771619 67.066 -0.771624 64.077 2.31486L26.4793 41.1388L13.0659 27.2879C10.0769 24.2014 5.23075 24.2014 2.24175 27.2879C-0.747251 30.3743 -0.747249 35.3785 2.24175 38.465L20.8548 57.6851C22.4036 59.2845 24.4511 60.0551 26.4805 59.9969C28.5091 60.0544 30.5556 59.2838 32.1039 57.6851L74.9011 13.492C77.8901 10.4055 77.8901 5.40135 74.9011 2.31487Z",
    fill: "#62FF8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrecticon);
export default __webpack_public_path__ + "static/media/correcticon.8632d926ee89e1594f9f49a8d8167d11.svg";
export { ForwardRef as ReactComponent };